// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".art__title[data-v-ebbaa0b2]{margin-bottom:10px;font-weight:700;width:100%;flex-shrink:0;order:3}@media(min-width:640px){.art__title[data-v-ebbaa0b2]{margin-bottom:0}}.art__sublabel[data-v-ebbaa0b2]{order:5;margin:0;font-size:13px}@media(min-width:640px){.art__sublabel[data-v-ebbaa0b2]{margin-top:.5em;margin-bottom:.5em;font-size:15px}}@media(max-width:959px){.object-layout[data-v-ebbaa0b2]{justify-content:center}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
